module.exports = __webpack_public_path__ + "img/logo.365763f7.png";